// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"231":"feed","263":"widget","791":"video"}[chunkId] + "." + {"231":"dc13d8d764c32ac6752b","263":"09d8ae438f9df6435686","791":"0d0a66cd4f7bed0a7281"}[chunkId] + ".js";
};